import React from "react"
import BannerBuilderCardField from "./BannerBuilderCardField"
import { Grid } from "@mui/material"
import { useListContext } from "react-admin"

const BannerBuilderGrid = () => {
    const { data, isLoading } = useListContext()

    if (isLoading) {
        return <></>
    }

    return (
        <Grid container spacing={1}>
            {data.map(record => (
                <Grid item key={record.id}>
                    <BannerBuilderCardField key={record.id} record={record} />
                </Grid>
            ))}
        </Grid>
    )
}

export default BannerBuilderGrid
